import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import DeleteModal from "../Item/DeleteModal";
import ResultModal from "../Common/ResultModal";
import ListAdminButtons from "../Common/ListAdminButtons";
import SpinnerLoading from "../Common/SpinnerLoading";
import { Form, Modal } from "react-bootstrap";
import {
  itemServices,
  globalServices,
  priceListServices,
} from "../../Services";
import XLSX from "xlsx";
import * as dateHelper from "../../Helpers/DateHelper";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import {
  currencyPriceList,
  currencyTagSessionName,
  doublePriceEndDate,
  priceListIdSessionName,
} from "../../Config/Consts";
import {
  euroCurrencyFormatter,
  knCurrencyFormatter,
} from "../../Helpers/CurrencyFormatters";
import AddItemModal from "../Item/AddItemModal";
// lista artikala iz cjenika /api/item/search šalješ odabrani priceListId u bodyu
const ItemsTab = ({ priceListId, storeId }) => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [itemId, setItemId] = useState(null);
  const history = useHistory();
  const { isMobile, locTab } = useContext(GlobalContext);
  const { t: translator } = useTranslation();
  const { roleId } = useContext(AuthContext);
  const { cashier, accountant, manager } = roles;

  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 50,
    pageIndex: 0,
  });
  const [resultModal, setResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  const [items, setItems] = useState([]);
  const [update, setUpdate] = useState(new Date());
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteAllModal, setShowDeleteAllModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [priceLists, setPriceLists] = useState();
  const [priceListStores, setPriceListStores] = useState(null);
  const [copyPriceListId, setCopyPriceListId] = useState();
  const [filters, setFilters] = useState({
    searchName: "",
    priceListId: priceListId,
  });

  useEffect(() => {
    setSelectedItems([]);
    setIsLoading(true);
    if (locTab === "priceList" || locTab === "products") {
      itemServices
        .getSearch({
          priceListId: filters.priceListId,
          storeId: storeId,
          searchName: filters.searchName,
          pageIndex: pagination.pageIndex,
          pageSize: pagination.pageSize,
        })
        .then((data) => {
          console.log("DD", data);
          setIsLoading(false);

          setItems(data.data.items);
          setPagination({ ...pagination, totalCount: data.data.totalCount });
        });
    }
  }, [update, filters, locTab]);

  useEffect(() => {
    globalServices.getPriceListStores(storeId).then((res) => {
      const priceId = sessionStorage.getItem(priceListIdSessionName);
      if (res?.data.find((x) => String(x.id) === String(priceId))) {
        setFilters({ ...filters, priceListId: priceId });
      }
      setPriceListStores(res?.data);
    });
  }, []);

  const handleToAdd = () => {
    const currencyTagValue = priceListStores.find(
      (x) => String(x.id) === String(filters.priceListId)
    ).name;

    sessionStorage.setItem(currencyTagSessionName, currencyTagValue);
    history.push(`/add-item/${filters.priceListId}`);
  };

  const handleToUpdate = () => {
    if (selectedItems.length !== 1) return false;
    history.push(`/edit-item/${filters.priceListId}/${selectedItems}`);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });
    setPagination({ ...pagination, pageIndex: 0 });
  };

  const handleHideDeleteModal = () => setShowDeleteModal(false);
  const handleHideDeleteAllModal = () => setShowDeleteAllModal(false);

  const confirmDelete = () => {

    itemServices
      .deleteItems({
        priceListId: filters.priceListId,
        items: selectedItems,
      })
      .then((res) => {
        setSelectedItems([]);
        handleHideDeleteModal();
        setUpdate(new Date());
        setResultModal({
          ...resultModal,
          title: translator("TenantDetail-ItemTab-SuccessDeleteModal-Title"),
          text: translator("TenantDetail-ItemTab-SuccessDeleteModal-Text"),
          show: true,
          btnClass: "btn btn-primary",
        });
      })
      .catch((err) =>{
        setSelectedItems([]);
        setResultModal({
          ...resultModal,
          title: translator("TenantDetail-ItemTab-UnsuccessDeleteModal-Title"),
          text: translator("TenantDetail-ItemTab-UnsuccessDeleteModal-Text"),
          show: true,
          btnClass: "btn btn-primary",
        })
      }
       
      );
  };

  const confirmDeleteAll = () => {
    itemServices
      .deleteAllItems({
        priceListId: filters.priceListId,
        storeId:storeId
      })
      .then((res) => {
        setSelectedItems([]);
        handleHideDeleteAllModal();
        setUpdate(new Date());
        setResultModal({
          ...resultModal,
          title: translator("TenantDetail-ItemTab-SuccessDeleteAllModal-Title"),
          text: translator("TenantDetail-ItemTab-SuccessDeleteAllModal-Text"),
          show: true,
          btnClass: "btn btn-primary",
        });
      })
      .catch((err) =>
        setResultModal({
          ...resultModal,
          title: translator("TenantDetail-ItemTab-UnsuccessDeleteModal-Title"),
          text: translator("TenantDetail-ItemTab-UnsuccessDeleteModal-Text"),
          show: true,
          btnClass: "btn btn-primary",
        })
      );
  };

  const handleCloseResultModal = () => {
    setSelectedItems([]);
    setResultModal({ show: false });
  };

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedItems([...selectedItems, row.itemId]);
    } else {
      setSelectedItems(selectedItems.filter((p) => p !== row.itemId));
    }
  };

  const handleOnSelectAll = (isSelect) => {
    if (isSelect) {
      setSelectedItems(items.map((x) => x.itemId));
    } else {
      setSelectedItems([]);
    }
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  const handleBulkImport = () => {
    history.push(`/item-bulk-import/${filters.priceListId}`);
  };

  const handleExport = () => {
    itemServices
      .getSearch({
        priceListId: filters.priceListId,
        searchName: filters.searchName,
        pageIndex: 0,
        pageSize: pagination.totalCount,
      })
      .then((res) => {
        let wb = XLSX.utils.book_new();
        console.log("export", res.data.items);
        const wsItemsHeading = [
          [
            translator("Id"),
            translator("Name"),
            translator("Code"),
            translator("BarCode"),
            translator("Description"),
            translator("IsService"),
            translator("Pn"),
            translator("UnitOfMeasure"),
            translator("TaxRate"),
            translator("ItemGroup"),
            translator("Price"),
            "Pp",
            "Klasifikacija"
          ],
        ];
        let wsItems = XLSX.utils.aoa_to_sheet(wsItemsHeading);
        XLSX.utils.sheet_add_json(
          wsItems,
          res.data.items.map((x) => {
            return {
              id: x.itemId,
              barCode: x.barCode,
              code: x.code,
              description: x.description,
              isService: x.isService === true ? "Da" : "Ne",
              pn: x.pn ?? 0,
              pp: x.pp ?? 0,
              price: x.price,
              unitOfMeasureName: x.unitOfMeasureTag,
              taxRateName: x.taxRateName,
              itemGroupName: x.itemGroupName,
              name: x.name,
              classNumber: x.classNumber
            };
          }),
          {
            header: [
              "id",
              "name",
              "code",
              "barCode",
              "description",
              "isService",
              "pn",
              "unitOfMeasureName",
              "taxRateName",
              "itemGroupName",
              "price",
              "pp",
              "classNumber"
            ],
            skipHeader: true,
            origin: -1,
          }
        );

        XLSX.utils.book_append_sheet(wb, wsItems, "Items");

        const fileName = `Cjenik_${dateHelper.formatUtcToYYYYMMDDHH_24MMSS(
          new Date()
        )}.xlsx`;
        XLSX.writeFile(wb, fileName);
      });
  };

  const handleHideCopyModal = () => setShowCopyModal(false);

  const handleCopy = () => {
    setShowCopyModal(true);
    const tId = Number(sessionStorage.getItem("locTenant"));
    if (!priceLists) {
      globalServices.getPriceLists(tId).then((res) => {
        setPriceLists(res.data.filter((x) => x.id != filters.priceListId));
      });
    }
  };

  const handleConfirmCopy = () => {
    priceListServices
      .copyPriceList({
        copyFromPriceListId: copyPriceListId,
        copyToPriceListId: filters.priceListId,
      })
      .then((res) => {
        handleHideCopyModal();
        if (res.data.success) {
          setResultModal({
            title: translator("CopyListPrice-Success-Title"),
            text: translator("CopyListPrice-Success-Text"),
            show: true,
            btnClass: "btn btn-primary",
          });
        } else {
          setResultModal({
            title: translator("CopyListPrice-Error-Title"),
            text: translator(res.data.message),
            show: true,
            btnClass: "btn btn-primary",
          });
        }
      })
      .catch((err) => {
        handleHideCopyModal();
        setResultModal({
          title: translator("CopyListPrice-Error-Title"),
          text: translator("CopyListPrice-Error-Text"),
          show: true,
          btnClass: "btn btn-primary",
        });
      });
  };

  const handleSelectCopyPriceListChange = (e) => {
    setCopyPriceListId(e.target.value);
  };

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        remote
        keyField="itemId"
        data={data}
        columns={columns}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
          hideSizePerPage: true,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            name="workingMode"
            checked={selectedItems.find((x) => x === row.itemId)}
            onChange={(e) => handleOnSelect(row, e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  function currencyFormatter(cell, row) {
    if (row?.currencyTag === currencyPriceList.kn) {
      return knCurrencyFormatter(cell);
    } else if (row?.currencyTag === currencyPriceList.euro) {
      return euroCurrencyFormatter(cell);
    } else {
      return cell;
    }
  }

  function actionHeaderFormatter(cell, rows) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            name="workingMode"
            checked={
              items &&
              items.length > 0 &&
              !items
                .map((p) => p.itemId)
                .some((p) => selectedItems.indexOf(p) < 0)
            }
            onChange={(e) => handleOnSelectAll(e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  const columns = [
    {
      dataField: "itemId",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      headerFormatter: actionHeaderFormatter,
      formatter: actionFormatter,
      hidden: [cashier, accountant, manager].includes(Number(roleId))
        ? true
        : false,
    },
    {
      dataField: "name",
      text: translator("TenantDetail-ItemTab-TableHeader-Name"),
      sort: true,
    },

    {
      dataField: "itemGroupName",
      text: translator("TenantDetail-ItemTab-TableHeader-ItemGroup"),
      sort: true,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "price",
      text: translator("TenantDetail-ItemTab-TableHeader-Price"),
      sort: true,
      style: { fontWeight: 600 },
      formatter: currencyFormatter,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "unitOfMeasureName",
      text: translator("TenantDetail-ItemTab-TableHeader-UnitOfMeasure"),
      sort: true,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "taxRateName",
      text: translator("TenantDetail-ItemTab-TableHeader-TaxRate"),
      sort: true,
      hidden: Boolean(isMobile),
    },
  ];

  const handleToDetailItem = () => {
    history.push(`/item-details/${priceListId}/${selectedItems}`);
  };

  return (
    <div className="p-2">
      <div className="container-fluid p-0">
        <div className="card-body pl-0">
          <div className="row justify-content-between">
            <div className="form-group d-flex flex-wrap justify-content-between col-xxl-6  col-xl-8 col-md-12">
              <Form.Group className="col-sm-12 col-md-8">
                <Form.Label>{translator("Search")}</Form.Label>
                <input
                  className="form-control"
                  name="searchName"
                  type="text"
                  placeholder={translator("Item-Tab-Search")}
                  defaultValue={filters.searchName}
                  onChange={handleInputChange}
                />
              </Form.Group>
              {priceListStores && doublePriceEndDate > new Date() && (
                <Form.Group className="col-sm-12 col-md-4">
                  <Form.Label>
                    {translator("ItemsTab-PickAPricelist")}
                  </Form.Label>
                  <Form.Control
                    as="select"
                    defaultValue={
                      sessionStorage.getItem(priceListIdSessionName) ||
                      priceListId
                    }
                    onChange={(e) => {
                      sessionStorage.setItem(
                        priceListIdSessionName,
                        e.target.value
                      );
                      setFilters({ ...filters, priceListId: e.target.value });
                    }}
                  >
                    {priceListStores?.map((x) => (
                      <option value={x.id}>{x.name}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              )}
              <Form.Group className="col-sm-12 col-md-12">
                {/* <!--<a
                  href="/Fiskalna blagajna - korisnička uputstva_euro.pdf"
                  target="_blank"
                >
                  Preuzmi upute za euro
                </a>--> */}
              </Form.Group>
            </div>
          </div>

          <ListAdminButtons
            selectedItemsLength={selectedItems.length}
            handleToAdd={
              [cashier, accountant, manager].includes(Number(roleId))
                ? null
                : handleToAdd
            }
            handleToUpdate={
              [cashier, accountant, manager].includes(Number(roleId))
                ? null
                : handleToUpdate
            }
            handleDelete={
              [cashier, accountant, manager].includes(Number(roleId))
                ? null
                : () => setShowDeleteModal(true)
            }
            handleBulkImport={
              [cashier, accountant, manager].includes(Number(roleId))
                ? null
                : handleBulkImport
            }
            handleExport={
              [cashier, accountant, manager].includes(Number(roleId))
                ? null
                : handleExport
            }
            handleCopy={
              [cashier, accountant, manager].includes(Number(roleId))
                ? null
                : handleCopy
            }
            handleToDetailItem={
              [cashier, accountant, manager].includes(Number(roleId))
                ? null
                : handleToDetailItem
            }
            copyText={translator("ItemsTab-copyText-CopyPriceList")}
            handleDeleteAll={
              [cashier, accountant, manager].includes(Number(roleId))
                ? null
                : () => setShowDeleteAllModal(true)
            }
          />

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={items}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}
        </div>
      </div>

      <DeleteModal
        show={showDeleteModal}
        handleHide={handleHideDeleteModal}
        title={translator("TenantDetail-ItemTab-DeleteModal-Title")}
        text={translator("TenantDetail-ItemTab-DeleteModal-Text")}
        confirmDelete={confirmDelete}
      />

<DeleteModal
        show={showDeleteAllModal}
        handleHide={handleHideDeleteAllModal}
        title={translator("TenantDetail-ItemTab-DeleteAllModal-Title")}
        text={translator("TenantDetail-ItemTab-DeleteAllModal-Text")}
        confirmDelete={confirmDeleteAll}
      />

      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass={resultModal.btnClass}
        handleClose={handleCloseResultModal}
      />
      <AddItemModal
        itemId={itemId}
        priceListId={priceListId}
        show={showAddModal}
        handleClose={() => {
          setItemId(null);
          setShowAddModal(false);
        }}
      />
      <Modal show={showCopyModal} onHide={handleHideCopyModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {translator("ItemTab-ModalTitle-PriceListCopy")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label htmlFor="ddlStore">
              {translator("ItemTab-ModalBody-Text")}:
            </label>
            <select
              className="form-control"
              onChange={handleSelectCopyPriceListChange}
            >
              <option value="-1">
                {translator("ItemTab-ModalBody-SelectOption")}
              </option>
              {priceLists &&
                priceLists.map((x) => (
                  <option key={x.id} value={x.id}>
                    {x.name}
                  </option>
                ))}
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary"
            data-dismiss="modal"
            onClick={handleHideCopyModal}
          >
            {translator("Btn-Cancel")}
          </button>
          <button
            onClick={handleConfirmCopy}
            type="button"
            disabled={!(copyPriceListId && copyPriceListId !== "-1")}
            className="btn btn-primary"
          >
            {translator("ItemTab-Btn-Copy")}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ItemsTab;
